import { render, staticRenderFns } from "./GeneralLedgerList.vue?vue&type=template&id=1d6db9e4&scoped=true"
import script from "./GeneralLedgerList.vue?vue&type=script&lang=js"
export * from "./GeneralLedgerList.vue?vue&type=script&lang=js"
import style0 from "./GeneralLedgerList.vue?vue&type=style&index=0&id=1d6db9e4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6db9e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d6db9e4')) {
      api.createRecord('1d6db9e4', component.options)
    } else {
      api.reload('1d6db9e4', component.options)
    }
    module.hot.accept("./GeneralLedgerList.vue?vue&type=template&id=1d6db9e4&scoped=true", function () {
      api.rerender('1d6db9e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/gledger/GeneralLedgerList.vue"
export default component.exports